"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function boldStyle(style) {
    return style + 'font-weight:bold;';
}
exports.default = boldStyle;



//////////////////
// WEBPACK FOOTER
// ./node_modules/file2html-ooxml/lib/word/styles/b.js
// module id = 1798
// module chunks = 0